import { ISelectOption } from 'app/interfaces/ISelectOption';
import { MapperConnection } from 'app/model/adfDataMapper/mapperConnection';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { Dataset, IDataflowSource } from 'shell-models-lib';
import { DataFlowSource } from '../dataflow/dataflow-source';
import { CosmosDBStoreType } from '../dataflow/dataset-settings/cosmos-sql-settings';

export enum SchemaLoadStatus {
    NOT_STARTED,
    LOADING,
    LOADED,
    LOADING_FAILED
}

export interface IMapperTable extends IDataflowSource {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dslConnectorProperties?: Map<string, any>;
    datasetType?: DatasetFormatType;

    // whether the columns have been fetched via import schema call
    schemaLoadStatus?: SchemaLoadStatus;

    /*
    * If the schema is not already present for target table at its linked service location,
    * it is the first load scenario (e.g.: if empty folder is selected for delta than this
    * option will be 'true' as no schema will be there for first load)
    * This option should never be true for the sources
    */
    isFirstLoad?: boolean;

    isSchemaDrifted?: boolean;

    wasExpectedSchemaImportError?: boolean;
    schemaImportError?: string;
    isSchemaInferError?: boolean;
    tableName?: string;

    /*
    * This is used to store schema for the table in scenarios when we do not want to update
    * the table after schema import call
    */
    shadowDataflowSource?: DataFlowSource;
}

export interface IMapperConnectionInfo {
    connection: MapperConnection;
    tables: IMapperTable[];
}

export interface IMapperEntity {
    entityName: string;
    dataset: Dataset;
    isAutoCreated?: boolean;
}

export interface ICosmosDBMapperEntity {
    collectionName: string;
    storeType: CosmosDBStoreType;
}

export interface ICassandraMapperEntity extends IMapperEntity {
    tableName: string;
    schemaName: string;
    watermarkOptions?: Array<ISelectOption<string>>;
    watermarkSelected?: string;
    schemaLoadStatus: SchemaLoadStatus;
}

export interface IEventHubsMapperEntity extends IMapperEntity {
    eventHubsName?: string;
    eventHubsNamePattern?: string;
    format: string;
    schemaInferenceType?: string;
    payloadSchema?: string;
    includeHeaders?: boolean;
    numSampleRecords?: number;
}

export interface IKafkaMapperEntity extends IMapperEntity {
    subscribe?: string;
    subscribePattern?: string;
    format: string;
    schemaInferenceType?: string;
    payloadSchema?: string;
    includeHeaders?: boolean;
    numSampleRecords?: number;
}

export interface ISqlBasedMapperEntity extends IMapperEntity {
    watermarkOptions: Array<ISelectOption<string>>;
    watermarkSelected: string;
    schemaLoadStatus: SchemaLoadStatus;
    isNativeCDC?: boolean;
}

export interface INewEntity extends IMapperEntity {
    schemaName: string;
}
